module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: _vm.innerDisabled ? 'disabled' : ''
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "disabled": _vm.innerDisabled
    },
    on: {
      "change": _vm.hanldeFileChange,
      "click": function($event) {
        return _vm.$emit('input-click', $event)
      }
    }
  }), _vm._v(" "), (_vm.loading) ? [_vm._t("loading", [_c('div', {
    staticClass: "img-loading"
  }, [_vm._v("上传中...")])])] : (_vm.previewSrc) ? [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.previewSrc
    }
  })] : [_vm._t("input", [_c('div', {
    staticClass: "plus-icon"
  })])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68d87fc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleImageUpload/index.vue
// module id = 833
// module chunks = 1